require([
	"templates",
    "indexView"
],
function(Templates, IndexView){
	Templates.init(); 

    // render our index view
    var indexView = new IndexView();
    indexView.render();
});
define("index", function(){});

